import type { TranslationMessages } from '../types';

export const inventory: TranslationMessages = {
  name: 'Tồn kho',
  add: 'Thêm tồn kho',
  scanQR: 'Cập nhật tồn kho',
  edit: 'Chỉnh sửa tồn kho',
  deleteAction: 'Xóa tồn kho',
  create: 'Tạo tồn kho',
  editDescription: 'Cập nhật thông tin chi tiết tồn kho',
  createDescription: 'Thêm một mục tồn kho mới vào hệ thống',
  list: 'Danh sách tồn kho',
  search: 'Tìm kiếm tồn kho...',
  warehouse: {
    name: 'Kho hàng',
    placeholder: 'Chọn kho hàng',
  },
  category: {
    name: 'Danh mục',
    placeholder: 'Chọn danh mục',
  },
  ingredient: {
    name: 'Nguyên liệu',
    placeholder: 'Chọn nguyên liệu (tùy chọn)',
    none: 'Không có nguyên liệu',
    quickCreate: 'Tạo nhanh nguyên liệu',
  },
  product: {
    name: 'Sản phẩm',
    placeholder: 'Chọn sản phẩm (tùy chọn)',
    none: 'Không có sản phẩm',
    help: 'Chọn một sản phẩm cho các mặt hàng cơ bản (ví dụ: Fanta, Surprise, Pepsi). Để trống nếu liên kết với nguyên liệu.',
    searchPlaceholder: 'Tìm kiếm sản phẩm...',
  },
  filter: 'Lọc',
  clear: 'Xóa',
  all: 'Tất cả',
  status: 'Trạng thái',
  price: 'Giá',
  basicInfo: 'Thông tin cơ bản',
  quantityPricing: 'Số lượng & Giá cả',
  dimensions: 'Kích thước gói hàng',
  fields: {
    code: 'Mã',
    codePlaceholder: 'Nhập mã tồn kho',
    name: 'Tên',
    description: 'Mô tả',
    quantity: 'Số lượng',
    totalPrice: 'Tổng giá',
    currency: 'Tiền tệ',
    width: 'Chiều rộng',
    height: 'Chiều cao',
    weight: 'Trọng lượng',
    volume: 'Thể tích',
    isPackage: 'Là gói hàng',
    namePlaceholder: 'Nhập tên tồn kho',
    descriptionPlaceholder: 'Nhập mô tả tồn kho',
    itemCount: 'Số lượng sản phẩm trong mỗi gói',
    itemCountPlaceholder: 'ví dụ: 12',
    itemCountHelp:
      'Tùy chọn: Số lượng sản phẩm riêng lẻ có trong mỗi gói hàng',
    quantityAnchor: 'Thuộc tính kiểm kho',
    quantityAnchorPlaceholder: 'Chọn thuộc tính (tùy chọn)',
    quantityAnchorHelp:
      'Chọn thuộc tính để sử dụng cho việc tính toán số lượng tự động. Khi được đặt, số lượng sẽ được tính từ các giá trị còn lại và không thể chỉnh sửa thủ công.',
    noAnchor: 'Không có thuộc tính (nhập số lượng thủ công)',
    anchorItemCount: 'Số lượng sản phẩm',
    anchorWeight: 'Trọng lượng',
    anchorVolume: 'Thể tích',
    calculated: 'Được tính toán',
    quantityHelp:
      'Tổng sản phẩm: {total} ({quantity} gói × {itemCount} sản phẩm)',
    quantityCalculatedHelp:
      'Số lượng được tính tự động từ thuộc tính đã chọn',
    currentStock:
      'Tồn kho hiện tại: {total} sản phẩm ({quantity} gói × {itemCount} sản phẩm/gói)',
    currentQuantity: 'Số lượng hiện tại: {quantity}',
    updateStock: 'Cập nhật tồn kho',
    remainingItems: 'Số lượng sản phẩm còn lại',
    remainingItemsHelp:
      'Tổng số lượng sản phẩm còn lại. Số lượng sẽ được tính là: số lượng còn lại / số lượng mỗi gói',
    remainingWeight: 'Trọng lượng còn lại',
    remainingWeightHelp:
      'Tổng trọng lượng còn lại. Số lượng sẽ được tính là: trọng lượng còn lại / trọng lượng mỗi gói',
    remainingVolume: 'Thể tích còn lại',
    remainingVolumeHelp:
      'Tổng thể tích còn lại. Số lượng sẽ được tính là: thể tích còn lại / thể tích mỗi gói',
  },
  code: 'Mã',
  quantity: 'Số lượng',
  totalPrice: 'Tổng giá',
  currency: 'Tiền tệ',
  scanQrCode: 'Quét mã QR tồn kho',
  scannerReady: 'Máy quét sẵn sàng',
  scanning: 'Đang quét...',
  processing: 'Đang xử lý...',
  scannerInstructions: 'Hướng dẫn sử dụng máy quét',
  pointCamera: 'Hướng camera vào mã QR tồn kho',
  ensureGoodLighting: 'Đảm bảo ánh sáng tốt',
  holdSteady: 'Giữ camera ổn định cho đến khi quét xong',
  invalidQRFormat:
    'Định dạng mã QR không hợp lệ. Vui lòng quét mã QR tồn kho.',
  customerQRDetected:
    'Mã QR này dành cho check-in khách hàng, không phải quản lý tồn kho',
  qrProcessingFailed: 'Không thể xử lý mã QR',
  scannerError: 'Lỗi máy quét',
  messages: {
    created: 'Tạo mục tồn kho thành công',
    updated: 'Cập nhật mục tồn kho thành công',
    deleted: 'Xóa mục tồn kho thành công',
    error_creating: 'Lỗi khi tạo mục tồn kho',
    error_updating: 'Lỗi khi cập nhật mục tồn kho',
    error_deleting: 'Lỗi khi xóa mục tồn kho',
    error_loading: 'Lỗi khi tải danh sách tồn kho',
    confirm_delete: 'Bạn có chắc chắn muốn xóa mục tồn kho này?',
  },
  qrCode: 'Mã QR',
  printQR: 'In mã QR',
  provider: {
    name: 'Nhà cung cấp',
    placeholder: 'Chọn nhà cung cấp (tùy chọn)',
    none: 'Không có nhà cung cấp',
  },
  deleteTitle: 'Xóa mục tồn kho',
  delete: {
    message:
      'Bạn có chắc chắn muốn xóa mục tồn kho này? Hành động này không thể hoàn tác.',
  },
  qrCodeManager: 'Quản lý mã QR',
  currentQuantity: 'Số lượng hiện tại',
  generating: 'Đang tạo...',
  generate: 'Tạo',
  downloadQR: 'Tải xuống mã QR',
  scanQRCode: 'Quét mã QR',
  scan: 'Quét',
  generateQRCode: 'Tạo mã QR',
  scanInstructions: 'Hướng dẫn quét',
  scanForCounting: 'Quét để đếm tồn kho',
  scanForDeduction: 'Quét để trừ kho',
  scanForAdjustment: 'Quét để điều chỉnh kho',
};
